// Any changes need to be done in colors.scss as well
export const colors = {
    black: '#202020',
    transparent: 'transparent',
    white: '#ffffff',
    'gray-50': '#e5e5e5',
    'gray-75': '#f5f5f5',
    'gray-100': '#f2f2f2',
    'gray-200': '#e0e0e0',
    'gray-250': '#b0b0b0',
    'gray-300': '#949494',
    'gray-350': '#808080',
    'gray-400': '#707070',
    'gray-450': '#606060',
    'gray-500': '#505050',
    'gray-600': '#404040',
    'gray-700': '#303030',
    'gray-800': '#000000',
    'gray-900': '#101010',
    'blue-100': '#e6f3fb',
    'blue-200': '#d0e7f5',
    'blue-300': '#a1ceec',
    'blue-400': '#62aedf',
    'blue-500': '#409dd8',
    'ecru-100': '#f5f2ed',
    'ecru-200': '#ece5db',
    'ecru-300': '#d8cab6',
    'ecru-400': '#bea786',
    'ecru-500': '#b49a74',
    'green-100': '#f2f7e0',
    'green-200': '#e9efc1',
    'green-300': '#d3df82',
    'green-400': '#b6ca2f',
    'green-500': '#a4b62a',
    'pink-100': '#fae5ec',
    'pink-200': '#f6cadb',
    'pink-300': '#ef96b6',
    'pink-400': '#e55086',
    'pink-500': '#e13775',
    'purple-100': '#eeecf7',
    'purple-200': '#ded9ef',
    'purple-300': '#bdb3dd',
    'purple-400': '#9181c6',
    'purple-500': '#7e6cbc',
    helsana: '#9a0941', // alias of red-600
    'red-100': '#ebced9',
    'red-200': '#d79db3',
    'red-300': '#c26b8d',
    'red-400': '#bb0c50',
    'red-500': '#ad0b49',
    'red-600': '#9a0941',
    'red-700': '#7d1c3a',
    'yellow-100': '#fff6d9',
    'yellow-200': '#ffeeb2',
    'yellow-300': '#fedd66',
    'yellow-400': '#fec600',
    'yellow-500': '#e5b300',
    'signal-yellow': '#ffb116',
    'signal-red-negative': '#ffaa99',
    'signal-red': '#d4402e',
    'signal-pink': '#f40084',
    'signal-green': '#5f9901',
};
